import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import i18n from 'utils/I18n';

import CustomAlert from 'component/base/CustomAlert';
import ActionBottom from 'component/campaign/ActionBottomSection';
import Brand from 'component/campaign/Brand';
import CheckInSection, {
  ACTION_BUTTON_STATUS,
} from 'component/campaign/CheckInSection';
import DetailDescription from 'component/campaign/DetailDescription';
import ImageSlider from 'component/campaign/ImageSlider';
import Instruction from 'component/campaign/Instruction';
import PointRequiredSection from 'component/campaign/PointRequiredSection';
import SharedSection, { BlockedSharedSection } from 'component/campaign/SharedSection';
import ShortDescription from 'component/campaign/ShortDescription';
import StampSection from 'component/campaign/StampSection';
import Stock from 'component/campaign/Stock';
import BreadCrumbs from 'component/common/BreadCrumbs';
import PickupStore from 'component/coupon/PickUpStoreSection';
import TicketInfoSection from 'component/ticket/TicketInfoSection';
import {
  CAMPAIGN_TYPE_COUPON,
  CAMPAIGN_TYPE_EARNING,
  CAMPAIGN_TYPE_STAMP,
  CAMPAIGN_TYPE_TICKET,
  EARNING_RULE_PURCHASE,
} from 'services/CampaignAPIHelper';

import { createAction, detectIsMobile } from 'utils';
import { APP_NAME, DOWNLOAD_APP_DOMAIN, WEB_DOMAIN } from 'utils/Config';
import {
  CustomerSelectionBehavior,
  CouponSelectionType,
} from 'utils/CustomEnums';
import { detectIsMobileByScreenWidth, detectIsPadOrMobileByScreenWidth } from 'utils/ScreenUtils';
import { DownloadSectionMobile, DownloadSectionWeb } from 'component/common/NoWebappDownloadSection'
import { hideDownloadAppSection } from 'utils/UIConfigUtils'
import { getShareCampaignUrl } from 'utils/CampaignUtil';
import './CampaignDetail.scss';
import { navigateBackHomePage } from 'utils/WeChatUtil';

@connect(({ campaignDetail, users, store, myCoupon }) => ({
  ...campaignDetail,
  language: users.language,
  membershipID: users.userInfo.memberShipID,
  campaignStores: store.campaignStore,
  selectedStore: myCoupon.selectedStore,
  selectedUsageMedium: myCoupon.selectedUsageMedium,
  applicableStoreIsLoading: store.loadingApplicableStores,
  isLogin: users.isLogin,
}))
class CampaignDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // showScanQRCodeModal: false,
      qrCodeString: '',
      showScanner: false,
      showUnavailable: false,
    };
    this.hideDownloadApp = hideDownloadAppSection()
  }

  componentDidMount() {
    this.campaignID =
      this.props.history.location.state?.campaignID ||
      this.props.match.params?.id;
    this.props.dispatch(
      createAction('campaignDetail/getCampaignDetail')({
        campaignID: this.campaignID,
      }),
    );
    this.props.dispatch(
      createAction('store/getCampaignStores')({
        campaignId: this.campaignID,
      }),
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.language !== prevProps.language) {
      this.props.dispatch(
        createAction('campaignDetail/getCampaignDetail')({
          campaignID: this.campaignID,
        }),
      );
    }
    if (
      prevProps.hasError !== this.props.hasError &&
      this.props.hasError &&
      !this.state.showUnavailable
    ) {
      this.setState({ showUnavailable: true });
    }
  }

  componentWillUnmount() {
    this.props.dispatch(
      createAction('campaignDetail/updateState')({
        actionButtonStatus: ACTION_BUTTON_STATUS.NORMAL,
        participateCampaignErrorMessage: "",
      }),
    );
  }

  hideModal = () => {
    this.setState({ showUnavailable: false });
  };

  showImageSlider = () => {
    if (this.props[this.campaignID]) {
      return (
        <ImageSlider
          className="campaign_detail_custom_image_slider"
          images={this.props[this.campaignID].data.images}
        />
      );
    } else {
      return (
        <ImageSlider
          className="campaign_detail_custom_image_slider"
          images={[]}
        />
      );
    }
  };

  outOfStockTag = (noMargin = false) => {
    return this.props[this.campaignID].data.basic.outOfStock ? (
      <label
        className="offer_tag out_of_stock_tag"
        style={noMargin ? { marginLeft: 0 } : {}}
      >
        <div
          className={`offer_state ${detectIsPadOrMobileByScreenWidth() ? 'tag-menu-2' : 'button-large'
            }`}
        >
          {this.props.t('campaignDetail:OUT OF STOCK')}
        </div>
      </label>
    ) : null;
  };

  showTag = () => {
    if (this.props[this.campaignID]) {
      if (this.props[this.campaignID].data.basic.isFeatured) {
        return (
          <>
            <label className="featured_tag">
              <div
                className={`feature ${detectIsPadOrMobileByScreenWidth() ? 'tag-menu-2' : 'button-large'
                  }`}
              >
                {this.props.t('featured_tag')}
              </div>
            </label>
            {this.outOfStockTag()}
          </>
        );
      } else if (this.props[this.campaignID].data.basic.isOnlyForYou) {
        return (
          <>
            <label className="offer_tag">
              <div
                className={`offer_state ${detectIsPadOrMobileByScreenWidth() ? 'tag-menu-2' : 'button-large'
                  }`}
              >
                {this.props.t('home_only_for_you')}
              </div>
            </label>
            {this.outOfStockTag()}
          </>
        );
      } else {
        return this.outOfStockTag(true);
      }
    }
  };

  name = () => {
    if (this.props[this.campaignID]) {
      if (this.props[this.campaignID].data.basic.name) {
        return this.props[this.campaignID].data.basic.name;
      }
    }
  };

  showBrand = () => {
    if (this.props[this.campaignID]) {
      if (
        this.props[this.campaignID].data.brand &&
        this.props[this.campaignID].data.brand.shown
      ) {
        return <Brand brand={this.props[this.campaignID].data.brand}></Brand>;
      } else {
        return '';
      }
    }
  };

  showShortDescription = () => {
    if (this.props[this.campaignID]) {
      if (this.props[this.campaignID].data.summary) {
        return (
          <ShortDescription
            description={this.props[this.campaignID].data.summary}
          ></ShortDescription>
        );
      }
    }
  };

  renderMask = () => {
    return detectIsMobileByScreenWidth();
  };

  showInstruction = () => {
    if (this.props[this.campaignID]) {
      if (this.props[this.campaignID].data.instructions.shown) {
        return (
          <Instruction
            renderMask={this.renderMask()}
            instructions={this.props[this.campaignID].data.instructions}
          />
        );
      } else {
        return '';
      }
    }
  };

  hideDevidingLine = () => {
    if (this.props[this.campaignID]) {
      if (
        this.props[this.campaignID].data.instructions.shown &
        this.props[this.campaignID].data.description.shown
      ) {
        return false;
      } else {
        return true;
      }
    }
  };

  showDescription = () => {
    if (this.props[this.campaignID]) {
      if (this.props[this.campaignID].data.description.shown) {
        return (
          <DetailDescription
            renderMask={this.renderMask()}
            description={this.props[this.campaignID].data.description}
          />
        );
      }
    }
  };

  showRightSection = () => {
    if (detectIsMobileByScreenWidth()) {
      return null;
    }
    if (this.props[this.campaignID]) {
      const campaignType = this.props[this.campaignID]?.data?.campaignType;
      const inBlackoutPeriod =
        this.props[this.campaignID]?.data?.inBlackoutPeriod;

      if (campaignType === CAMPAIGN_TYPE_TICKET) {
        // if (!this.hideDownloadApp) {
        //   return <DownloadSectionWeb />
        // }
        return (
          <TicketInfoSection
            isEventActive={this.props[this.campaignID]?.data?.basic?.isActive}
            detailData={this.props[this.campaignID]?.data?.ticket}
          />
        );
      } else if (campaignType === CAMPAIGN_TYPE_COUPON) {
        const coupon = this.props[this.campaignID].data.coupon;
        const stores = this.props.campaignStores;
        let couponSelectionType = null;
        const {
          customerStoreSelectionBehavior,
          customerOnlineOfflineSelectionBehavior,
        } = coupon;
        const showStoreSelection = [
          CustomerSelectionBehavior.SELECT_WHEN_ACQUIRE,
          CustomerSelectionBehavior.NO_LIMIT,
        ].includes(customerStoreSelectionBehavior);
        const hasStore = showStoreSelection && stores && stores.length > 0;
        if (showStoreSelection) {
          if (
            customerStoreSelectionBehavior ===
            CustomerSelectionBehavior.NO_LIMIT
          ) {
            couponSelectionType = CouponSelectionType.VIRTUAL_STORE;
          } else {
            couponSelectionType = CouponSelectionType.STORE;
          }
        }
        const showMediumSelection = [
          CustomerSelectionBehavior.SELECT_WHEN_ACQUIRE,
          CustomerSelectionBehavior.NO_LIMIT,
        ].includes(customerOnlineOfflineSelectionBehavior);
        if (showMediumSelection) {
          if (
            customerOnlineOfflineSelectionBehavior ===
            CustomerSelectionBehavior.NO_LIMIT
          ) {
            couponSelectionType = CouponSelectionType.VIRTUAL_ONLINE_OFFLINE;
          } else {
            couponSelectionType = CouponSelectionType.ONLINE_OFFLINE;
          }
        }
        if (!this.hideDownloadApp) {
          return <DownloadSectionWeb />
        }
        return (
          <div>
            {hasStore || showMediumSelection ? (
              <PickupStore
                defaultSelectedFirst={true}
                stores={stores}
                applicableStoreIsLoading={this.props.applicableStoreIsLoading}
                couponSelectionType={couponSelectionType}
                isCampaignBuyCoupon={true}
              />
            ) : null}
            <PointRequiredSection
              coupon={this.props[this.campaignID].data.coupon}
              inBlackoutPeriod={inBlackoutPeriod}
              from="campaign"
              hasStore={hasStore}
              selectedStore={this.props.selectedStore}
              hasUsageMedium={showMediumSelection}
              selectedUsageMedium={this.props.selectedUsageMedium}
              campaignID={this.campaignID}
            />
          </div>
        );
      } else if (
        campaignType === CAMPAIGN_TYPE_EARNING &&
        this.props[this.campaignID].actionBar?.earningRuleType &&
        this.props[this.campaignID].actionBar.earningRuleType !==
        EARNING_RULE_PURCHASE
      ) {
        if (!this.hideDownloadApp) {
          return <DownloadSectionWeb />
        }
        return (
          <CheckInSection
            earnRule={this.props[this.campaignID].actionBar}
            inBlackoutPeriod={inBlackoutPeriod}
            campaignID={this.campaignID}
          />
        );
      } else if (campaignType === CAMPAIGN_TYPE_STAMP) {
        return (
          <StampSection
            campaignID={this.campaignID}
            inBlackoutPeriod={inBlackoutPeriod}
          />
        );
      }
    }
  };

  showExpriyDate = () => {
    if (this.props[this.campaignID]) {
      return this.props[this.campaignID].data.basic.endDate;
    }
  };

  showActionBar = () => {
    if (!this.props[this.campaignID]) {
      return null
    }
    const actionBarTypes = [CAMPAIGN_TYPE_COUPON, CAMPAIGN_TYPE_EARNING, CAMPAIGN_TYPE_TICKET]
    const campaignType = this.props[this.campaignID].data.campaignType
    
    if (!actionBarTypes.includes(campaignType)) {
      return null
    }

    const earningRuleType = this.props[this.campaignID].actionBar.earningRuleType
    if (campaignType === CAMPAIGN_TYPE_EARNING && earningRuleType === EARNING_RULE_PURCHASE) {
      return null
    }
    if (!this.hideDownloadApp && campaignType !== CAMPAIGN_TYPE_TICKET) {
      return <DownloadSectionMobile isActionBar={true} />
    }
    return (
      <ActionBottom
        campaign={this.props[this.campaignID].data}
        campaignId={this.campaignID}
        actionBar={this.props[this.campaignID].actionBar}
      />
    );
  };

  showStock = () => {
    // console.log("@@200: ", this.props[this.campaignID]);
    if (
      this.props[this.campaignID] &&
      this.props[this.campaignID].data.campaignType === CAMPAIGN_TYPE_COUPON &&
      this.props[this.campaignID]?.apiResult
        .coupon_campaign_type_should_show_coupon_stock
    ) {
      return (
        <>
          <Stock coupon={this.props[this.campaignID].data.coupon} />
          <Row className="dividing"></Row>
        </>
      );
    }

    if (
      this.props[this.campaignID] &&
      this.props[this.campaignID].data.ticket?.isTicket &&
      this.props[this.campaignID].data.ticket?.showStock
    ) {
      return (
        <>
          <Stock coupon={this.props[this.campaignID].data.ticket} />
          <Row className="dividing"></Row>
        </>
      );
    }
  };

  openAppClicked = () => {
    const url = `${DOWNLOAD_APP_DOMAIN}/?page=campaignDetail&id=${this.campaignID}`;
    window.location = url;
  };

  clearParticipateCampaignError = () => {
    this.props.dispatch(
      createAction('campaignDetail/updateState')({
        participateCampaignErrorMessage: "",
      }),
    );
  }

  render() {
    const isPadOrMobileView = detectIsPadOrMobileByScreenWidth();
    const campaignName = this.props[this.campaignID]?.data?.basic?.name
    const coverImage = this.props[this.campaignID]?.data?.images?.[0];
    const sharePath = `/campaign/${this.campaignID}`
    const shareTitle = `${APP_NAME} - ${campaignName}`;
    const url = getShareCampaignUrl(this.campaignID);
    const message = `東瀛遊 - ${campaignName}. ${this.props.t('campaignDetail:checkItNow')} \n ${url} `;
    const breadList = [
      { path: '/', name: 'home_home' },
      { path: '/offer/LATEST', name: 'home_offers' },
      { path: '', name: 'campaign_detail' },
    ];
    const isOnlyForYou = this.props[this.campaignID]?.data?.basic?.isOnlyForYou;
    return (
      <div className="user_container_background">
        <Container className="campaign_detail_container">
          <BreadCrumbs breadList={breadList} />
          <Row>
            <Col className="d-md-block left_section">
              <Row>{this.showImageSlider()}</Row>
              {this.showTag()}
              <Row>
                <div
                  className={`offer_title ${isPadOrMobileView ? 'headline' : 'title-large'
                    }`}
                >
                  {this.name()}
                </div>
              </Row>
              <label
                className={`expiry_date ${isPadOrMobileView ? 'body-2' : 'field-text'
                  }`}
                hidden={
                  this.props[this.campaignID] &&
                    this.props[this.campaignID].data.basic.endDate
                    ? false
                    : true
                }
              >
                {this.showExpriyDate()}
              </label>
              <Row
                className="dividing top_dividing"
                hidden={
                  this.props[this.campaignID] &&
                  ![CAMPAIGN_TYPE_COUPON, CAMPAIGN_TYPE_TICKET].includes(
                    this.props[this.campaignID].data.campaignType,
                  )
                }
              ></Row>
              {this.showStock()}
              {this.showBrand()}
              <Row>{this.showShortDescription()}</Row>
              <Row>{this.showInstruction()}</Row>
              <Row
                className="dividing_line campaign_dividing_line"
                hidden={this.hideDevidingLine()}
              ></Row>
              <Row>{this.showDescription()}</Row>
              {this.props[this.campaignID] &&
                this.props[this.campaignID].data.campaignType ===
                CAMPAIGN_TYPE_STAMP ? (
                <>
                  <div className="stamp-section-left">
                    <StampSection
                      campaignID={this.campaignID}
                      inBlackoutPeriod={
                        this.props[this.campaignID].data.inBlackoutPeriod
                      }
                    />
                  </div>
                  {
                    !this.hideDownloadApp ? <DownloadSectionMobile /> : null
                  }
                </>
              ) : (
                <></>
              )}

              {!isOnlyForYou && <BlockedSharedSection title={shareTitle} message={message} pathname={sharePath} weChatShareTitle={campaignName} weChatShareImgUrl={coverImage} />}
              <Row className="fixed-bottom mobile_bottom_bar">
                {this.showActionBar()}
              </Row>
            </Col>

            <Col className=" col-md-4 right_section">
              <div className="float_right_section">
                {this.showRightSection()}
                {!isOnlyForYou && 
                  <SharedSection
                    title={shareTitle}
                    message={message}
                    pathname={sharePath}
                    weChatShareTitle={campaignName}
                    weChatShareImgUrl={coverImage}
                  />
                }
              </div>
            </Col>
          </Row>
          <CustomAlert
            show={this.props?.participateCampaignErrorMessage}
            onHide={this.clearParticipateCampaignError}
            title={''}
            message={this.props?.participateCampaignErrorMessage}
            leftbtn={''}
            rightbtn={this.props.t('campaign_ok')}
            rightAction={this.clearParticipateCampaignError}
          />
          <CustomAlert
            show={this.state.showUnavailable}
            onHide={this.hideModal}
            title={this.props.t('campaignDetail:campaignUnavailable')}
            message={''}
            leftbtn={''}
            rightbtn={this.props.t('campaign_ok')}
            rightAction={() => {
              this.hideModal();
              navigateBackHomePage({ history: this.props.history })
              this.props.dispatch(
                createAction('campaignDetail/updateState')({
                  hasError: false,
                }),
              );
            }}
          />
        </Container>
      </div>
    );
  }
}

export default withTranslation()(CampaignDetail);
